import api from '../../api/stoTrade'
import {
  calculateProfit,
  calculateTotalProfit,
  calculateTotal,
  calculateAll,
} from '../../utils/functions'
import _ from 'lodash'

export default {
  state: {
    localBalance: null,
    remoteBalance: null,
    shareBalance: null,
    calculatedShareBalance: null,
    calculatedShareBalanceAll: null,
    totalShareBalance: null,
    localBalanceLoading: false,
    remoteBalanceLoading: false,
    shareBalanceLoading: false,
    mseBalance: null,
    totalProfit: null,
    symbolProfits: null,
    feePercent: null,
    dividends: null,
    govBond: null
  },
  getters: {
    feePercent: (state) => state.feePercent,
    localBalance: (state) => state.localBalance,
    remoteBalance: (state) => state.remoteBalance,
    shareBalance: (state) => state.shareBalance,
    calculatedShareBalance: (state) => state.calculatedShareBalance,
    calculatedShareBalanceAll: (state) => state.calculatedShareBalanceAll,
    totalShareBalance: (state) => state.totalShareBalance,
    localBalanceLoading: (state) => state.localBalanceLoading,
    remoteBalanceLoading: (state) => state.remoteBalanceLoading,
    shareBalanceLoading: (state) => state.shareBalanceLoading,
    mseBalance: (state) => state.mseBalance,
    totalProfit: (state) => state.totalProfit,
    symbolProfits: (state) => state.symbolProfits,
    dividends: (state) => state.dividends,
    govBond: (state) => state.govBond
  },
  mutations: {
    SET_LOCAL_BALANCE: (state, localBalance) => {
      state.localBalance = localBalance
    },
    SET_REMOTE_BALANCE: (state, remoteBalance) => {
      state.remoteBalance = remoteBalance
    },
    SET_SHARE_BALANCE: (state, shareBalance) => {
      state.shareBalance = shareBalance
    },
    SET_CALCULATED_SHARE_BALANCE: (state, calculatedShareBalance) => {
      state.calculatedShareBalance = calculatedShareBalance
    },
    SET_CALCULATED_SHARE_BALANCE_ALL: (state, calculatedShareBalanceAll) => {
      state.calculatedShareBalanceAll = calculatedShareBalanceAll
    },
    SET_TOTAL_SHARE_BALANCE: (state, totalShareBalance) => {
      state.totalShareBalance = totalShareBalance
    },
    SET_LOCAL_BALANCE_LOADING: (state, loading) => {
      state.localBalanceLoading = loading
    },
    SET_REMOTE_BALANCE_LOADING: (state, loading) => {
      state.remoteBalanceLoading = loading
    },
    SET_SHARE_BALANCE_LOADING: (state, loading) => {
      state.shareBalanceLoading = loading
    },
    SET_MSE_BALANCE: (state, mseBalance) => {
      state.mseBalance = mseBalance
    },
    SET_TOTAL_PROFIT: (state, totalBalance) => {
      state.totalProfit = totalBalance
    },
    SET_SYMBOL_PROFITS: (state, symbolProfits) => {
      state.symbolProfits = symbolProfits
    },
    SET_USER_FEE: (state, feePercent) => {
      state.feePercent = feePercent
    },
    SET_DIVIDENDS: (state, dividends) => {
      state.dividends = dividends
    },
    SET_GOV_BOND: (state, govBond) => {
      state.govBond = govBond
    }
  },
  actions: {
    async fetchLocalBalance({ commit }) {
      commit('SET_LOCAL_BALANCE_LOADING', true)
      try {
        const { data } = await api.getLocalBalance()
        commit('SET_LOCAL_BALANCE', data)
      } catch (error) {
        console.log(error)
      }
      commit('SET_LOCAL_BALANCE_LOADING', false)
    },
    async fetchRemoteBalance({ commit }) {
      commit('SET_REMOTE_BALANCE_LOADING', true)
      try {
        const { data } = await api.getRemoteBalance()
        commit('SET_REMOTE_BALANCE', data)
      } catch (error) {
        console.log(error)
      } finally {
        commit('SET_REMOTE_BALANCE_LOADING', false)
      }
    },
    async fetchShareBalance({ commit, rootGetters }) {
      commit('SET_SHARE_BALANCE_LOADING', true)
      try {
        const { data } = await api.getShareBalance()
        if (data && data.length > 0) {
          commit('SET_SHARE_BALANCE', data)
          let calculated = []
          data.forEach((item) => {
            const tmpArr = calculateProfit(
              item.symbol,
              rootGetters.tradeHistory
            )
            if (
              typeof tmpArr != 'undefined' &&
              tmpArr[tmpArr.length - 1] &&
              tmpArr[tmpArr.length - 1].remainingQty
            ) {
              /* Back дээр аль хэдийн тооцоологдсон remainingQty-г энд дахин тооцоолсноос болж өгөөж болон
              дансны хувьцаан дээр зөрүүтэй гараад байгаа тул доорх залхуу аргаар түр шийдэв. Refactor хийвэл зохино. */
              if (item.value && item.value > 0 && tmpArr[tmpArr.length - 1].remainingQty != item.value)
                tmpArr[tmpArr.length - 1].remainingQty = item.value

              const sub = calculateTotalProfit(tmpArr)
              if (sub.length > 0) {
                calculated = calculated.concat(sub)
              }
            }
          })
          commit(
            'SET_CALCULATED_SHARE_BALANCE_ALL',
            calculateAll(rootGetters.tradeHistory)
          )
          commit('SET_CALCULATED_SHARE_BALANCE', calculated)
          commit('SET_TOTAL_SHARE_BALANCE', calculateTotal(calculated))
        }
      } catch (error) {
        console.log(error)
      }
      commit('SET_SHARE_BALANCE_LOADING', false)
    },
    async fetchMSEBalance({ commit }) {
      try {
        const { data } = await api.getRemoteBalance()
        const balance = data.find((item) => item.BalanceCode == 9999)
        const balance2 = data.find((item) => item.BalanceCode == 9992)
        const balance3 = data.find((item) => item.BalanceCode == 9991)
        if (balance && balance.Balance)
          commit('SET_MSE_BALANCE', balance.Balance)
        if (balance2 && balance2.Balance)
          commit('SET_DIVIDENDS', balance2.Balance)
        if (balance3 && balance3.Balance)
          commit('SET_GOV_BOND', balance3.Balance)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchTotalProfits({commit}) {
      try {
        const { data } = await api.getTotalProfits()
        commit('SET_TOTAL_PROFIT', data)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSymbolProfits({commit}) {
      try {
        const { data } = await api.getSymbolProfits()
        commit('SET_SYMBOL_PROFITS', data)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFees({commit}) {
      try {
        const { data } = await api.getFees()
        commit('SET_USER_FEE', data)
        // this.feePercent = data
      } catch (e) {
        console.error(e)
      }
    },
  },
}
